// extracted by mini-css-extract-plugin
export default {"dialog":"oJOcD","dialog__title":"rLkpw","dialog__actions":"ZPkLq"};